<template>
    <div id="app">
        <template v-if="$route.path!='/bookinfo'">
            <template v-if="!$root.getStorage('login')">
                <router-view></router-view>
            </template>
            <template v-else>
                <el-container>
                    <el-header height="48px" class="flex-n fac header">
                        <img class="logo" src="@/common/images/logo.png">
                        <div class="flex-n fac flex-1">
                            <div class="title textnowrap">{{storeName}}</div>
                            <div class="textnowrap">刺兔酒店管家 &nbsp;&nbsp;<span style="color:darkgray">[版本V202511]</span></div>
                        </div>

                        <div class="flex-n fac">
                            <store-list required v-model="storeId" size="mini" class="mr-10" @change="changeStore"
                                        @getName="getName"></store-list>
                            <el-badge :value="askCount>99?'99+':askCount" :hidden="!askCount" class="item">
                                <i class="el-icon-service c-point" :title="askCount?'您有未处理咨询记录':'无处理咨询记录'"
                                   @click="$router.push('/consultation/remind')"></i>
                            </el-badge>
                            <el-badge :value="orderWaitCount>99?'99+':orderWaitCount" :hidden="!orderWaitCount"
                                      class="item">
                                <i class="el-icon-document-checked c-point" :title="orderWaitCount?'您有未处理预定单':'无未处理预定单'"
                                   @click="$router.push('/reserve/remind')"></i>
                            </el-badge>
                            <div class="item flex-n fac">
                                <i class="el-icon-user"
                                   style="border-radius: 40px;border: 2px solid white;font-size: 20px"></i>
                                <div class="text textnowrap" style="margin-left: 5px">
                                    {{$root.getStorage('info').userName||'未命名'}}
                                </div>
                            </div>
                            <i class="el-icon-lock item c-point" title="修改密码" @click="changepass=true"></i>
                            <div class="text item textnowrap c-point" @click="exit">退出</div>
                        </div>
                    </el-header>
                </el-container>
                <el-container>
                    <!--菜单-->
                    <el-aside width="160px" class="aside">
                        <el-menu :router="true" :default-active="nowpage" background-color="#393d49"
                                 active-text-color="#ffffff" text-color="#c2c2c2">
                            <template v-for="item,index in menuList">
                                <el-menu-item :index="'/'+item.menuAction" v-if="item.children.length==0">{{item.menuName}}
                                </el-menu-item>
                                <el-submenu :index="index.toString()" v-else>
                                    <template slot="title">{{item.menuName}}</template>
                                    <el-menu-item-group v-for="itm,idx in item.children">
                                        <el-menu-item :index="itm.menuAction">{{itm.menuName}}</el-menu-item>
                                    </el-menu-item-group>
                                </el-submenu>
                            </template>
                            <!--<el-submenu index="20">-->
                                <!--<template slot="title">新加功能</template>-->
                                <!--<el-menu-item index="/settings/commission">提成设置</el-menu-item>-->
                            <!--</el-submenu>-->

                        </el-menu>
                    </el-aside>
                    <el-main class="main">
                        <router-view v-if="flag"></router-view>
                    </el-main>
                </el-container>

            </template>
            <setpassword :visible.sync="changepass"></setpassword>
        </template>
        <template v-else>
            <router-view></router-view>
        </template>
    </div>
</template>
<script>
    import Setpassword from "./views/component/setpassword";
    import StoreList from "./components/data/storeList";

    export default {
        components: {
            StoreList,
            Setpassword
        },
        name: "App",
        data() {
            return {
                changepass: false,
                storeId: '',
                storeList: [],
                nowpage: '',
                storeName: '',
                flag: true,
                value: '选项1',
                askCount: 100,
                orderWaitCount: 2,
                menuList: [],
                navConfig: {
                    index: 'index',
                    conremind: 'conremind',
                    conrecord: 'conrecord',
                    resremind: 'resremind',
                    resquery: 'resquery',
                    resrecord: 'resrecord',
                    weddingrecords: 'weddingrecords',
                    freserve: 'freserve',
                    fwedding: 'fwedding',
                    setbase: 'setbase',
                    setfield: 'setfield',
                    setextra: 'setextra',
                    setorder: 'setorder',
                    setmeal: 'setmeal',
                    setdate: 'setdate',
                    setuser: 'setuser'
                }
            }
        },
        mounted() {

            if (this.$route.path != '/bookinfo')
                this.getDic();
        },
        watch: {
            $route(to, from) {
                console.log('router:', to.path);
                //如果路由是登录状态
                if (to.path == '/bookinfo') {

                }
                else {
                    if (this.$root.getStorage('login')) {
                        if (to.path == '/' || to.path === '/login') {
                            this.nowpage = 'index'
                            this.$router.push('/index');

                        } else {
                            this.nowpage = to.path.split('/')[1];
                            this.getCount(this.storeId);


                        }
                        if (this.$root.getStorage('menuList')) {
                            this.menuList = this.$root.getStorage('menuList');
                        } else {
                            this.getMenu();
                        }
                    } else {
                        if (to.path != '/' && to.path != '/login')
                            this.$router.push('/');
                        this.nowpage = ''
                    }
                }


            },
            storeId(newval, oldval) {
                this.getCount(newval);
            },
            '$store.state.dicChange'(newval, oldval) {
                if (newval) {
                    console.log(this.$route)
                    if (this.$route.path != '/bookinfo') {
                        this.getDic();
                    }
                }
                console.log(newval, oldval)
            }
        },
        methods: {
            getDic() {
                if (!this.$root.getStorage('dic'))
                    this.$axios.post('dic/findAll', {}).then(res => {
                        console.log(res.data.list)
                        this.$root.setStorage('dic', res.data.list);
                        this.$store.state.dicChange = false;
                    }).catch(err => {
                        // this.$message.error(err.msg)
                    })
            },
            getMenu() {
                this.$axios.get('/menu/menuRecurrenceUser/1/1').then(res => {
                    console.log('动态菜单获取', res.data)
                    this.menuList = res.data.children;
                    this.$root.setStorage('menuList', res.data.children)
                }).catch(err => {
                    this.$message.error(err.msg)
                })
            },
            getCount(storeId) {
                // this.$root.setStorage('storeId',storeId);
                this.$axios.post('/preUserAsk/todoCount', {
                    storeId: this.$root.getStorage('storeId')
                }).then(res => {
                    console.log(res.data)
                    this.askCount = res.data.askCount;
                    this.orderWaitCount = res.data.orderWaitCount;
                }).catch(err => {
                    this.$message.error(err.msg)
                })
            },
            getName(name) {
                this.storeName = name;
                this.$store.state.storeName = name;
            },
            changeStore(id) {
                console.log(id)
                this.$root.setStorage('storeId', id);
                this.flag = false // 通过v-if移除router-view节点
                this.$nextTick(() => {
                    this.flag = true // DOM更新后再通过v-if添加router-view节点
                })
            },
            exit() {
                localStorage.clear();
                this.$store.state.dicChange = false;
                this.$router.push('/login');
            }
        }
    }
</script>
<style lang="scss">
    #app {
        height: 100vh;
        overflow-y: hidden;
        background: #f0f2f5;
    }

    /*#app::-webkit-scrollbar {*/
    /*display: none!important; !* Chrome Safari *!*/
    /*}*/
    .aside {
        height: calc(100vh - 48px);
        background: #393d49;
        overflow-x: hidden !important;
    }

    .aside::-webkit-scrollbar, .main::-webkit-scrollbar {
        display: none !important; /* Chrome Safari */
    }

    .header {
        color: #333;
        background: white;
        box-shadow: 0 10px 10px #e2e2e2;
        /*background: #464c5be5;*/
        .logo {
            width: 25px;
            height: 25px;
        }
        .title {
            padding: 0 20px;
            font-size: 18px;
            font-weight: bold;
        }
        i {
            font-size: 25px;
        }
        .item {
            margin: 0 10px;
        }
        .el-badge__content {
            height: 12px;
            line-height: 12px;
            padding: 0 4px;
            margin-top: 2px;
        }
        .text {
            font-size: 12px;
        }
    }

    .main {
        min-width: 980px;
        height: calc(100vh - 48px);
        overflow-x: hidden !important;
    }
</style>
<style scoped lang="scss">

    .el-menu-item {
        height: 45px !important;
        line-height: 45px !important;
        min-width: 159px !important;
        font-size: 13px !important;
    }

    .el-submenu__title, .el-submenu .el-menu-item {
        height: 35px !important;
        line-height: 35px !important;
    }

    .el-menu-item-group__title {
        padding: 0 !important;
    }

    .el-input--mini .el-input__inner {
        width: 150px;
    }
</style>